import { FC } from "react";

import BasicWidget, {
  BasicWidgetProps,
} from "src/dynamic-view-renderer/Widgets/BasicWidget/BasicWidget.tsx";
import { useCustomerClientSchemaQuery } from "src/graphql/anti-fraud/queries/customers/GetCustomerSchemasQuery";
import { useT } from "src/internationalization";

import WidgetContainer from "../WidgetContainer";

const WidgetCustomerSchema: FC<Omit<BasicWidgetProps, "itemSchema">> = ({
  widgetConfig,
  rowConfiguration,
  ...props
}) => {
  const t = useT();
  const { data: customerSchema, error: customerSchemaError } = useCustomerClientSchemaQuery();

  if (customerSchemaError) {
    return (
      <WidgetContainer widgetConfig={widgetConfig} rowConfiguration={rowConfiguration}>
        <div className="text-supportError mb-4">{t("general.clientSchemaError")}</div>
      </WidgetContainer>
    );
  }

  return (
    <BasicWidget
      {...props}
      itemSchema={customerSchema}
      widgetConfig={widgetConfig}
      rowConfiguration={rowConfiguration}
    />
  );
};

export default WidgetCustomerSchema;
